module.exports = __webpack_public_path__ + "static/media/downloadPdf.8cb12fb4.svg";